import React, { Fragment, useState, useEffect } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Row, Col, Tag, Input, Divider, InputNumber, Tooltip, FormInstance } from "antd";
import { CharacterVerify } from "Utility/RegExp";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setLTELimitDisabled, setLTE2LimitDisabled } from "Components/Topology/store/topologySlice";
import { BsFileEarmarkBreak } from "react-icons/bs";
// import { M300models } from "Utility/mode_name";
import { setFields } from "./setFields";

const { Option } = Select;
const { CheckableTag } = Tag;
const tagsData = ["SIM1", "SIM2"];

const BulkConfigFLte = React.memo(
  ({ SubmitConfigonFinish, form }: { SubmitConfigonFinish: (value: any) => void; form: FormInstance<any> }) => {
    const disp = useAppDispatch();
    // const [LTE1PinEnable, setLTE1PinEnable] = useState(false);
    // const [LTE2PinEnable, setLTE2PinEnable] = useState(false);
    const [LTERecoverAPN1, setLTERecoverAPN1] = useState(false);
    const [LTE1DataLimitEnable, setLTE1DataLimitEnable] = useState(false);
    const [LTE2DataLimitEnable, setLTE2DataLimitEnable] = useState(false);
    const { formData, selectedModel, importSource, LTELimitDisabled, LTE2LimitDisabled } = useAppSelector(
      (state) => state.topology
    );
    const [SelectedSIM, setSelectedSIM] = useState("SIM1");
    const lte = formData?.lte;

    useEffect(() => {
      //jusge if dual sim

      // setSelectedSIM("SIM1");
      // if (lte?.sim?.length === 1) {
      //   disp(setShowDualSim(false));
      // } else {
      //   disp(setShowDualSim(true));
      // }

      setLTERecoverAPN1(lte?.policy.recovery?.recover_apn?.enabled);
      setLTE1DataLimitEnable(lte?.limit?.[0]?.enabled);
      setLTE2DataLimitEnable(lte?.limit?.[1]?.enabled || false);

      disp(setLTELimitDisabled(false));
      disp(setLTE2LimitDisabled(false));

      if (importSource === "NewConfig") {
        return;
      }

      // setFields(lte, form);

      form.setFieldsValue({
        LTE_mode: lte?.config?.mode || "auto",
        LTE_mtu: lte?.config?.mtu || 1500,

        // LTE1_pin: lte?.sim?.[0]?.pin,
        // LTE1_puk: lte?.sim?.[0]?.puk,
        LTE1_apn1: lte?.sim?.[0]?.apn?.[0]?.apn,
        LTE1_username: lte?.sim?.[0]?.apn?.[0]?.auth?.username,
        LTE1_password: lte?.sim?.[0]?.apn?.[0]?.auth?.password,
        LTE1_auth: lte?.sim?.[0]?.apn?.[0]?.auth?.type || "none",

        // LTE2_pin: lte?.sim?.[1]?.pin,
        // LTE2_puk: lte?.sim?.[1]?.puk,
        LTE2_apn1: lte?.sim?.[1]?.apn?.[0]?.apn,
        LTE2_username: lte?.sim?.[1]?.apn?.[0]?.auth?.username,
        LTE2_password: lte?.sim?.[1]?.apn?.[0]?.auth?.password,
        LTE2_auth: lte?.sim?.[1]?.apn?.[0]?.auth?.type || "none",

        LTE1_limit_enabled: lte?.limit?.[0]?.enabled || false,
        LTE1_limit_mbyte: lte?.limit?.[0]?.limit_mbyte,
        LTE1_reset_day: lte?.limit?.[0]?.reset?.day || 31,
        LTE1_reset_hour: lte?.limit?.[0]?.reset?.hour || 23,
        LTE1_reset_minute: lte?.limit?.[0]?.reset?.minute || 0,
        LTE1_reset_second: lte?.limit?.[0]?.reset?.second || 0,

        LTE2_limit_mbyte: lte?.limit?.[1]?.limit_mbyte,
        LTE2_limit_enabled: lte?.limit?.[1]?.enabled || false,
        LTE2_reset_day: lte?.limit?.[1]?.reset?.day || 31,
        LTE2_reset_hour: lte?.limit?.[1]?.reset?.hour || 23,
        LTE2_reset_minute: lte?.limit?.[1]?.reset?.minute || 0,
        LTE2_reset_second: lte?.limit?.[1]?.reset?.second || 0,

        LTE_roaming: lte?.policy?.roaming || false,
        LTE_connect_retry_num: lte?.policy?.connect_retry_num || 3,
        LTE_recovery_down_time: lte?.policy?.recovery?.down_times,
        LTE_recovery_apn_enabled: lte?.policy?.recovery?.recover_apn.enabled || false,
        LTE_recovery_apn_action: lte?.policy?.recovery?.recover_apn.action,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    function handleTagChange(value: any) {
      setSelectedSIM(value);
    }
    return (
      <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>Ethernet</h2>
              <Divider className={styles.divider} />
              <Form.Item
                name="LTE_mode"
                label="LTE Config"
                rules={[{ required: true, message: "required!" }]}
                initialValue={"auto"}
              >
                <Select placeholder={"Auto/2G/3G/4G..."}>
                  <Option key={0} value={"auto"}>
                    Auto
                  </Option>
                  <Option key={1} value={"2G-only"}>
                    2G-only
                  </Option>
                  <Option key={3} value={"3G-only"}>
                    3G-only
                  </Option>
                  <Option key={4} value={"4G-only"}>
                    4G-only
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                name={"LTE_mtu"}
                label="MTU"
                rules={[
                  { required: true, message: "required!" },
                  {
                    type: "number",
                    max: 1500,
                    min: 700,
                    message: "MTU range should be 700-1500 ",
                  },
                ]}
                initialValue={1500}
              >
                <InputNumber placeholder={"700 ~ 1500"} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={10}>
              <h2>APN Config</h2>
              <Divider className={styles.divider} />
              {tagsData.map((tag) => (
                <CheckableTag key={tag} checked={SelectedSIM.indexOf(tag) > -1} onChange={() => handleTagChange(tag)}>
                  {tag}
                </CheckableTag>
              ))}
              {<h3></h3>}
              {/* <h3>SIM Configuration</h3> */}

              {/* <Form.Item
                name={"LTE1_pin"}
                label="PIN"
                rules={[
                  CharacterVerify,
                  {
                    pattern: /^[0-9]{4}$/,
                    message: "Invalid!!",
                  },
                ]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
              >
                <Input.Password autoComplete="new-password" placeholder={"******"} />
              </Form.Item>
              <Form.Item
                name={"LTE1_puk"}
                label="PUK"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
              >
                <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
              </Form.Item>

              <Form.Item
                name={"LTE2_pin"}
                label="PIN"
                rules={[
                  CharacterVerify,
                  {
                    pattern: /^[0-9]{4}$/,
                    message: "Invalid!!",
                  },
                ]}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
              </Form.Item>
              <Form.Item
                name={"LTE2_puk"}
                label="PUK"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Input.Password autoComplete="new-password" maxLength={30} placeholder={"******"} />
              </Form.Item> */}

              <h3>APN1</h3>

              <Form.Item
                name={"LTE1_apn1"}
                label="APN"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
              >
                <Input placeholder={"APN Name"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name={"LTE1_username"}
                label="User Name"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
              >
                <Input placeholder={"Name"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name={"LTE1_password"}
                label="Password"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
              >
                <Input.Password placeholder={"Password"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name="LTE1_auth"
                label="Auth Type"
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                initialValue={"none"}
              >
                <Select placeholder={"PAP/CHAP"}>
                  <Option key={0} value={"none"}>
                    NONE
                  </Option>
                  <Option key={1} value={"pap"}>
                    PAP
                  </Option>
                  <Option key={3} value={"chap"}>
                    CHAP
                  </Option>
                </Select>
              </Form.Item>

              <Form.Item
                name={"LTE2_apn1"}
                label="APN"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Input placeholder={"APN Name"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name={"LTE2_username"}
                label="User Name"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Input placeholder={"Name"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name={"LTE2_password"}
                label="Password"
                rules={[CharacterVerify]}
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
              >
                <Input.Password placeholder={"Password"} maxLength={30} />
              </Form.Item>
              <Form.Item
                name="LTE2_auth"
                label="Auth Type"
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                initialValue={"none"}
              >
                <Select placeholder={"PAP/CHAP"}>
                  <Option key={0} value={"none"}>
                    NONE
                  </Option>
                  <Option key={1} value={"pap"}>
                    PAP
                  </Option>
                  <Option key={3} value={"chap"}>
                    CHAP
                  </Option>
                </Select>
              </Form.Item>

              <h3>Data Limitation</h3>

              <Form.Item
                name={"LTE1_limit_enabled"}
                label="Limit Enabled"
                style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                rules={[{ required: true, message: "required!" }]}
                initialValue={false}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE1DataLimitEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>
              {LTE1DataLimitEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE1_limit_mbyte"}
                    label={
                      <span style={LTELimitDisabled ? { textDecoration: " line-through" } : {}}>
                        Max Data Limitation (MB)
                      </span>
                    }
                    rules={[{ required: LTELimitDisabled ? false : true, message: "required!" }]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <Input
                      type="number"
                      disabled={LTELimitDisabled}
                      style={{ width: "100%" }}
                      placeholder="1"
                      min={0}
                      addonAfter={
                        <Tooltip title="Exclude this field">
                          <BsFileEarmarkBreak
                            onClick={() => {
                              disp(setLTELimitDisabled(!LTELimitDisabled));
                              form.validateFields(["LTE1_limit_mbyte"]);
                            }}
                            className={styles.excludeIcon}
                          />
                        </Tooltip>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_day"}
                    label="Reset Date"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 31,
                        min: 1,
                        message: "Reset Date should be 1-31",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="1~31" min={1} max={31} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_hour"}
                    label="Hour"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 23,
                        min: 0,
                        message: "Reset Hour should be 0-23",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~23" min={0} max={23} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_minute"}
                    label="Minute"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Minute should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE1_reset_second"}
                    label="Second"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Second should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM1" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                </Fragment>
              )}

              <Form.Item
                name={"LTE2_limit_enabled"}
                label="Limit Enabled"
                style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                initialValue={false}
              >
                <Select
                  onChange={(value: any) => {
                    setLTE2DataLimitEnable(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>
              {LTE2DataLimitEnable && (
                <Fragment>
                  <Form.Item
                    name={"LTE2_limit_mbyte"}
                    label={
                      <span style={LTE2LimitDisabled ? { textDecoration: " line-through" } : {}}>
                        Max Data Limitation (MB)
                      </span>
                    }
                    rules={[{ required: LTE2LimitDisabled ? false : true, message: "required!" }]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <Input
                      type="number"
                      disabled={LTE2LimitDisabled}
                      style={{ width: "100%" }}
                      placeholder="1"
                      min={0}
                      addonAfter={
                        <Tooltip title="Exclude this field">
                          <BsFileEarmarkBreak
                            onClick={() => {
                              disp(setLTE2LimitDisabled(!LTE2LimitDisabled));
                              form.validateFields(["LTE2_limit_mbyte"]);
                            }}
                            className={styles.excludeIcon}
                          />
                        </Tooltip>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_day"}
                    label="Reset Date"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 31,
                        min: 1,
                        message: "Reset Date should be 1-31",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="1~31" min={1} max={31} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_hour"}
                    label="Hour"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 23,
                        min: 0,
                        message: "Reset Hour should be 0-23",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~23" min={0} max={23} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_minute"}
                    label="Minute"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Minute should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                  <Form.Item
                    name={"LTE2_reset_second"}
                    label="Second"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 59,
                        min: 0,
                        message: "Reset Second should be 0-59",
                      },
                    ]}
                    style={SelectedSIM !== "SIM2" ? { display: "none" } : {}}
                  >
                    <InputNumber style={{ width: "100%" }} placeholder="0~59" min={0} max={59} />
                  </Form.Item>
                </Fragment>
              )}

              <h3>Connect Policy</h3>
              <Form.Item
                name={"LTE_roaming"}
                label="Roaming"
                initialValue={false}
                rules={[{ required: true, message: "required!" }]}
              >
                <Select placeholder={"ON/OFF"}>
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>

              <Form.Item
                name={"LTE_connect_retry_num"}
                label="Connect Retry Number"
                rules={[{ required: true, message: "required!" }]}
              >
                <InputNumber style={{ width: "100%" }} placeholder="1" min={1} max={100} />
              </Form.Item>

              <h3>Recover APN</h3>
              <Form.Item
                name={"LTE_recovery_apn_enabled"}
                label="Recover APN"
                initialValue={false}
                rules={[{ required: true, message: "required!" }]}
              >
                <Select
                  onChange={(value: any) => {
                    setLTERecoverAPN1(value);
                  }}
                  placeholder={"ON/OFF"}
                >
                  {/* @ts-ignore */}
                  <Option key={0} value={true}>
                    ON
                  </Option>
                  {/* @ts-ignore */}
                  <Option key={1} value={false}>
                    OFF
                  </Option>
                </Select>
              </Form.Item>

              {LTERecoverAPN1 && (
                <Fragment>
                  <Form.Item
                    name={"LTE_recovery_down_time"}
                    label="Recover DownTimes"
                    rules={[
                      { required: true, message: "required!" },
                      {
                        type: "number",
                        max: 15,
                        min: 3,
                        message: "Down Time must between 3 to 15",
                      },
                    ]}
                    initialValue={3}
                  >
                    <InputNumber placeholder="3 ~ 15" style={{ width: "100%" }} />
                  </Form.Item>
                  <Form.Item
                    name="LTE_recovery_apn_action"
                    label="Recover Action"
                    rules={[{ required: true, message: "required!" }]}
                    initialValue={"reboot"}
                  >
                    <Select placeholder={"Reboot/Recover"}>
                      <Option key={0} value={"reboot"}>
                        Reboot
                      </Option>
                    </Select>
                  </Form.Item>
                </Fragment>
              )}
            </Col>
          </Row>
        </div>
      </Form>
    );
  }
);

export default BulkConfigFLte;

/////////////////////////////////////////////////////////////////////////////////////////////////////////

export const assemble = (values: any, LTELimitDisabled: boolean = false, LTE2LimitDisabled: boolean = false) => {
  let simArray = [];
  //SIM1
  let sim1Obj: any = {};

  // if (values.LTE1_pin) {
  //   sim1Obj.pin = values.LTE1_pin;
  // }

  // if (values.LTE1_puk) {
  //   sim1Obj.puk = values.LTE1_puk;
  // }

  // sim1Obj.pin = values.LTE1_pin;
  // sim1Obj.puk = values.LTE1_puk;

  let apn1Array = [];
  let apn1Obj: any = {};

  apn1Obj.apn = values.LTE1_apn1 || "";

  let Auth1Obj: any = {};

  // if (values.LTE1_password) {
  //   Auth1Obj.password = values.LTE1_password;
  // }

  // if (values.LTE1_auth) {
  //   Auth1Obj.type = values.LTE1_auth;
  // }

  Auth1Obj.username = values.LTE1_username || "";
  Auth1Obj.password = values.LTE1_password || "";
  Auth1Obj.type = values.LTE1_auth || "none";

  apn1Obj.auth = Auth1Obj;
  apn1Array.push(apn1Obj);
  sim1Obj.apn = apn1Array;
  simArray.push(sim1Obj);

  //limit
  let limitArray: any = [
    {
      enabled: values.LTE1_limit_enabled,
      // limit_mbyte: values.LTE1_limit_mbyte || 0,
      reset: {
        day: values.LTE1_reset_day || 31,
        hour: values.LTE1_reset_hour || 23,
        minute: values.LTE1_reset_minute || 0,
        second: values.LTE1_reset_second || 0,
      },
    },
  ];
  if (!LTELimitDisabled) {
    limitArray[0].limit_mbyte = parseInt(values.LTE1_limit_mbyte) || 0;
  }

  //SIM2

  let sim2Obj: any = {};

  // if (values.LTE2_pin) {
  //   sim2Obj.pin = values.LTE2_pin;
  // }

  // if (values.LTE2_puk) {
  //   sim2Obj.puk = values.LTE2_puk;
  // }

  // sim2Obj.pin = values.LTE2_pin;
  // sim2Obj.puk = values.LTE2_puk;

  let apn2Array = [];
  let apn2Obj: any = {};

  apn2Obj.apn = values.LTE2_apn1 || "";

  // apn2Obj.ipv6_enabled = values.LTE2_ipv6_enabled || false;
  if (values.LTE2_ipv6_enabled !== undefined) {
    apn2Obj.ipv6_enabled = values.LTE2_ipv6_enabled;
  }

  let Auth2Obj: any = {};

  // if (values.LTE2_password) {
  //   Auth2Obj.password = values.LTE2_password;
  // }

  // if (values.LTE2_auth) {
  //   Auth2Obj.type = values.LTE2_auth;
  // }

  Auth2Obj.username = values.LTE2_username || "";
  Auth2Obj.password = values.LTE2_password || "";
  Auth2Obj.type = values.LTE2_auth || "none";

  apn2Obj.auth = Auth2Obj;

  apn2Array.push(apn2Obj);

  sim2Obj.apn = apn2Array;
  simArray.push(sim2Obj);
  // sim2-limitation

  let limit2: any = {
    enabled: values.LTE2_limit_enabled || false,
    // limit_mbyte: values.LTE2_limit_mbyte || 0,
    reset: {
      day: values.LTE2_reset_day || 31,
      hour: values.LTE2_reset_hour || 23,
      minute: values.LTE2_reset_minute || 0,
      second: values.LTE2_reset_second || 0,
    },
  };

  if (!LTE2LimitDisabled) {
    limit2.limit_mbyte = parseInt(values.LTE2_limit_mbyte) || 0;
  }

  limitArray.push(limit2);

  const lteObj: any = {
    config: { mode: values.LTE_mode, mtu: values.LTE_mtu },
    sim: simArray,
    limit: limitArray,
    policy: {
      roaming: values.LTE_roaming,
      recovery: {
        down_times: values.LTE_recovery_down_time || 3,
        recover_apn: {
          enabled: values.LTE_recovery_apn_enabled,
          action: values.LTE_recovery_apn_action || "reboot",
        },
      },
    },
  };

  if (values.LTE_connect_retry_num) {
    lteObj.policy.connect_retry_num = values.LTE_connect_retry_num;
  }

  return lteObj;
};
